// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement } from 'react';
import './qualificationsEnergy.scss';
import { useTranslation } from 'react-i18next';
import useCheckColor from 'store/hooks/useCheckColor';
import { QualificationsModel } from 'api/types/Qualifications';

interface Props {
  userId: number | null;
  dataQualificationsEnergy:
    | {
        [key: string]: QualificationsModel[];
      }
    | null
    | undefined;
}

const QualificationsEnergy = (props: Props): ReactElement => {
  const { userId, dataQualificationsEnergy } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <>
      {dataQualificationsEnergy &&
      dataQualificationsEnergy !== null &&
      Object.keys(dataQualificationsEnergy)?.length > 0 ? (
        <Box
          id="userQualificationsEnergyBox"
          name={t('userQualificationsDesktop.userQualificationEnergy')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userQualificationsEnergyContent">
            {Object.keys(dataQualificationsEnergy)?.map((k) => (
              <>
                {Object.keys(dataQualificationsEnergy?.[k]).map((kk) => (
                  <DesktopItem
                    id="qualifications"
                    name={
                      dataQualificationsEnergy?.[k]?.[kk]?.qualificationName
                    }
                  >
                    <>
                      {dataQualificationsEnergy?.[k]?.[kk]
                        ?.expirationQualificationDate !== null ? (
                        <div
                          className={`dateQualificationEnergyBox ${checkColor(
                            dataQualificationsEnergy?.[k]?.[kk]
                              ?.expirationQualificationDate,
                            'uprawnienia',
                            'energetyczne'
                          )}`}
                        >
                          <div
                            className={`dateQualificationEnergyLabel ${checkColor(
                              dataQualificationsEnergy?.[k]?.[kk]
                                ?.expirationQualificationDate,
                              'uprawnienia',
                              'energetyczne'
                            )}`}
                          >
                            {t(
                              'userQualificationsDesktop.expirationQualificationDate'
                            )}
                          </div>
                          <div
                            className={`dateQualificationEnergyValue ${checkColor(
                              dataQualificationsEnergy?.[k]?.[kk]
                                ?.expirationQualificationDate,
                              'uprawnienia',
                              'energetyczne'
                            )}`}
                          >
                            {
                              dataQualificationsEnergy?.[k]?.[kk]
                                ?.expirationQualificationDate
                            }
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {dataQualificationsEnergy?.[k]?.[kk]
                        ?.qualificationNumber !== null &&
                      dataQualificationsEnergy?.[k]?.[kk]
                        ?.qualificationNumber !== ' ' &&
                      dataQualificationsEnergy?.[k]?.[kk]
                        ?.qualificationNumber !== '' ? (
                        <div className="qualificationEnergyDetailBox">
                          <div className="qualificationEnergyLabel">
                            {t('userQualificationsDesktop.qualificationNumber')}
                          </div>
                          <div className="qualificationEnergyValue">
                            {
                              dataQualificationsEnergy?.[k]?.[kk]
                                ?.qualificationNumber
                            }
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {dataQualificationsEnergy?.[k]?.[kk]?.children &&
                      Object.keys(dataQualificationsEnergy?.[k]?.[kk]?.children)
                        .length > 0
                        ? Object.keys(
                            dataQualificationsEnergy?.[k]?.[kk]?.children
                          )?.map((kkk) => {
                            if (
                              kkk === 'Czynność' &&
                              dataQualificationsEnergy?.[k]?.[kk]?.children?.[
                                kkk
                              ] &&
                              Object.keys(
                                dataQualificationsEnergy?.[k]?.[kk]?.children?.[
                                  kkk
                                ]
                              ).length > 0
                            )
                              return (
                                <>
                                  <div className="qualificationEnergyDetailBox">
                                    <div className="qualificationEnergyLabel">
                                      {kkk}
                                    </div>
                                  </div>
                                  {Object.keys(
                                    dataQualificationsEnergy?.[k]?.[kk]
                                      ?.children?.[kkk]
                                  )?.map((kkkk) => {
                                    return (
                                      <div className="qualificationEnergyDetailBox">
                                        <div className="qualificationEnergyValue">
                                          {
                                            dataQualificationsEnergy?.[k]?.[kk]
                                              ?.children[kkk]?.[kkkk]
                                          }
                                        </div>
                                      </div>
                                    );
                                  })}
                                </>
                              );

                            return null;
                          })
                        : ''}
                      {dataQualificationsEnergy?.[k]?.[kk]?.children &&
                      Object.keys(dataQualificationsEnergy?.[k]?.[kk]?.children)
                        .length > 0
                        ? Object.keys(
                            dataQualificationsEnergy?.[k]?.[kk]?.children
                          )?.map((kkk) => {
                            if (
                              kkk === 'Rodzaj' &&
                              dataQualificationsEnergy?.[k]?.[kk]?.children?.[
                                kkk
                              ] &&
                              Object.keys(
                                dataQualificationsEnergy?.[k]?.[kk]?.children?.[
                                  kkk
                                ]
                              ).length > 0
                            )
                              return (
                                <>
                                  <div className="qualificationEnergyDetailBox">
                                    <div className="qualificationEnergyLabel">
                                      {kkk}
                                    </div>
                                  </div>
                                  {Object.keys(
                                    dataQualificationsEnergy?.[k]?.[kk]
                                      ?.children?.[kkk]
                                  )?.map((kkkk) => {
                                    return (
                                      <div className="qualificationEnergyDetailBox">
                                        <div className="qualificationEnergyValue">
                                          {
                                            dataQualificationsEnergy?.[k]?.[kk]
                                              ?.children[kkk]?.[kkkk]
                                          }
                                        </div>
                                      </div>
                                    );
                                  })}
                                </>
                              );

                            return null;
                          })
                        : ''}
                      <div className="borderTop" />
                    </>
                  </DesktopItem>
                ))}
              </>
            ))}
          </div>
        </Box>
      ) : (
        ''
      )}
    </>
  );
};

export default QualificationsEnergy;
